/** 通用格式化工具 */

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '-'
  const d = new Date(iso)
  if (isNaN(d.getTime())) return '-'
  return d.toLocaleString('zh-CN')
}

export function formatBytes(n: number | null | undefined): string {
  if (n == null || n <= 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let i = 0
  let size = n
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024
    i++
  }
  return `${size >= 100 ? size.toFixed(0) : size.toFixed(1)} ${units[i]}`
}

export function formatQuota(bytes: number | null | undefined): string {
  if (bytes == null) return '不限'
  const gb = bytes / (1024 * 1024 * 1024)
  if (gb >= 1) return `${gb >= 100 ? gb.toFixed(0) : gb.toFixed(1)} GB`
  const mb = bytes / (1024 * 1024)
  return `${mb.toFixed(0)} MB`
}

export function formatUsers(max: number | null | undefined): string {
  if (max == null) return '不限'
  return String(max)
}

/** 把字符串 id 段从路径取出（去掉前缀斜杠） */
export function lastPathSegment(pathname: string): string {
  const clean = pathname.replace(/\/+$/, '')
  const idx = clean.lastIndexOf('/')
  return idx >= 0 ? clean.slice(idx + 1) : clean
}
